import naja from 'naja'
import toastr from 'toastr'

// Zachytávání a zobrazování payload messages
naja.addEventListener('payload', (event) => {
    const payloadMessage = event.detail.payload?.payloadMessage
    if(payloadMessage) {
        showToast(payloadMessage.message, payloadMessage.type)
    }
})

// Zobrazování flash messages
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#toast-container > div').forEach(msgDiv => {
        // Z elementu načteme data
        const type = msgDiv.getAttribute('type') ?? 'info'
        const message = msgDiv.textContent ?? ''

        // Element odstraníme ze stránky
        msgDiv.remove()

        // Zobrazíme Toast
        showToast(message, type)
    })
})

export default function showToast(message: string, type: string = 'info'): void
{
    toastr[type](message, '', {
        positionClass: "toast-top-right",
        closeButton: false,
        preventDuplicates: false,
        newestOnTop: true,
        timeOut: type === 'error' ? 0 : 2000,
        extendedTimeOut: 0,
    })
}
